/**
 * File upload configuration
 * Centralized config for supported file types
 */

// Supported file extensions (used in accept attribute)
export const SUPPORTED_EXTENSIONS = [
  '.pdf',
  '.png',
  '.jpg',
  '.jpeg',
  '.gif',
  '.webp',
  '.xls',
  '.xlsx',
  '.csv',
  '.dwg',
  '.dxf',
  '.svg',
  '.md',
  '.txt',
] as const;

// Accept string for file input elements
export const FILE_ACCEPT_STRING = SUPPORTED_EXTENSIONS.join(',');

// Human-readable format categories for error messages
export const SUPPORTED_FORMAT_CATEGORIES = {
  images: ['PNG', 'JPG', 'GIF', 'WebP', 'SVG'],
  documents: ['PDF', 'TXT', 'Markdown'],
  spreadsheets: ['Excel', 'CSV'],
  cad: ['DWG', 'DXF'],
} as const;

// Human-readable list for display
export function getSupportedFormatsText(): string {
  return 'PDF, TXT, Markdown, images (PNG, JPG, GIF, WebP), spreadsheets (Excel, CSV), and CAD files (DWG, DXF, SVG)';
}

// Max file size (25MB)
export const MAX_FILE_SIZE = 25 * 1024 * 1024;

// Max files per upload
export const MAX_FILES_PER_UPLOAD = 5;
